// extracted by mini-css-extract-plugin
export default {"lx_list":"index_lx_list_-WeDA clearfix"};